import React from 'react';
import { AutoLoginLayout } from '@isyc-react/auth/modules/pods/login/auto';
import { AutoLoginLoggedForm } from '@isyc-react/auth/modules/pods/login/auto';
export const AutoLoginLoggedScene = () => {
    return (React.createElement(AutoLoginLayout, null,
        React.createElement(AutoLoginLoggedForm, null)));
};
